import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Card, Box } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';

import Stepper from 'components/Stepper';
import CurrentSignupStep from 'containers/SignupPages/CurrentSignupStep';
import { signupStepsList } from 'containers/SignupPages/constants';
import { useLayoutStyles, StyledWrapper } from 'containers/SignupPages/styles';
import {
  getCurrentSignupStepSelector,
  getIsLoadingSelector,
} from 'store/user/selectors';
import { submitSignupStep, setSignupStep } from 'store/user/actions';
import {
  SignupPagePropsType,
  SignupPageSelectorsType,
} from 'containers/SignupPages/types';

const SignupPage = (props: SignupPagePropsType) => {
  const classes = useLayoutStyles();
  const {
    currentSignupStepObj,
    submitSignupStep,
    setSignupStep,
    isLoading,
  } = props;
  return (
    <StyledWrapper container justify="center" alignContent="center">
      <Box className={classes.box}>
        <Card className={classes.paper}>
          <Stepper
            stepsList={signupStepsList}
            activeStep={currentSignupStepObj.index}
          />
          <Divider />
          <CurrentSignupStep
            stepName={currentSignupStepObj.name}
            onSubmitStep={submitSignupStep}
            isLoading={isLoading}
            setSignupStep={setSignupStep}
          />
        </Card>
      </Box>
    </StyledWrapper>
  );
};

const mapStateToProps = createStructuredSelector<any, SignupPageSelectorsType>({
  currentSignupStepObj: getCurrentSignupStepSelector,
  isLoading: getIsLoadingSelector,
});

const mapDispatchToProps = {
  submitSignupStep,
  setSignupStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(SignupPage);
